import script from "./investApplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./investApplyList.vue?vue&type=script&lang=ts&setup=true"

import "./investApplyList.vue?vue&type=style&index=0&id=b925beec&lang=less"

const __exports__ = script;

export default __exports__